(function () {
  'use strict';

  function formatMoney(cents, format) {
    var raw = Number(cents);
    if (isNaN(raw)) raw = 0;
    var neg = raw < 0;
    raw = Math.abs(Math.round(raw));
    function withDelimiters(precision, thousands, decimal) {
      if (precision && raw % 100 === 0) precision = 0;
      var parts = (raw / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var formatted = String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      switch (key) {
        case 'amount': return withDelimiters(2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(0, ' ', ',');
        case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
        default: return match;
      }
    });
    return neg ? '-' + formatted : formatted;
  }

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var payload = { page: location.pathname };
        Object.keys(data || {}).forEach(function (k) { payload[k] = data[k]; });
        Shopify.analytics.publish('minkmods:' + name, payload);
      }
    } catch (e) {
      /* tracking never blocks the page */
    }
  }

  // Each block runs on its own: one that throws is logged, and the rest of the page still works.
  function guard(fn) {
    try {
      return fn();
    } catch (e) {
      if (window.console && console.error) console.error('theme.js', e);
    }
  }

  function each(selector, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
      guard(function () { fn(el); });
    });
  }

  /* ---------- Visitors outside the US (by time zone; never hides prices or dates) ---------- */

  each('[data-intl-note]', function (intlNote) {
    var zoneName = '';
    try { zoneName = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { zoneName = ''; }
    var usZone = /^(America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Juneau|Sitka|Nome|Yakutat|Metlakatla|Adak|Boise|Detroit|Menominee|Indianapolis|Louisville|Fort_Wayne|Knox_IN|Puerto_Rico|Indiana\/.+|Kentucky\/.+|North_Dakota\/.+)|Pacific\/Honolulu|US\/.+)$/;
    if (zoneName && !/^(UTC|GMT|Etc\/.+)$/.test(zoneName) && !usZone.test(zoneName)) {
      document.documentElement.classList.add('is-intl');
      intlNote.hidden = false;
    }
  });

  /* ---------- Deadline bar: the first stage that is running now ---------- */

  each('[data-deadline-bar]', function (bar) {
    var labelEl = bar.querySelector('[data-deadline-label]');
    var countdownEl = bar.querySelector('[data-deadline-countdown]');
    var stages = [];
    var stagesEl = bar.querySelector('[data-deadline-stages]');
    if (stagesEl) {
      try { stages = JSON.parse(stagesEl.textContent) || []; } catch (e) { stages = []; }
    } else if (bar.getAttribute('data-end')) {
      stages = [{
        label: labelEl ? labelEl.textContent : '',
        start: bar.getAttribute('data-start') || '',
        end: bar.getAttribute('data-end')
      }];
    }
    stages = stages.map(function (stage) {
      var start = stage.start ? new Date(stage.start) : null;
      var end = stage.end ? new Date(stage.end) : null;
      return { label: String(stage.label || '').trim(), start: start, end: end };
    }).filter(function (stage) {
      if (!stage.label || !stage.end || isNaN(stage.end.getTime())) return false;
      return !(stage.start && isNaN(stage.start.getTime()));
    });
    if (!stages.length) {
      bar.remove();
      return;
    }

    var announce = document.querySelector('.announce:not([data-intl-note])');
    var timer = null;

    function running(now) {
      for (var i = 0; i < stages.length; i++) {
        if ((!stages[i].start || stages[i].start.getTime() <= now) && stages[i].end.getTime() > now) return stages[i];
      }
      return null;
    }

    function tick() {
      var now = Date.now();
      var stage = running(now);
      if (!stage) {
        bar.hidden = true;
        if (announce) announce.hidden = false;
        var upcoming = stages.some(function (s) { return s.start && s.start.getTime() > now; });
        if (!upcoming && timer) clearInterval(timer);
        return;
      }
      var totalSec = Math.floor((stage.end.getTime() - now) / 1000);
      var days = Math.floor(totalSec / 86400);
      var parts = [];
      if (days > 0) parts.push(days + 'd');
      parts.push(String(Math.floor((totalSec % 86400) / 3600)).padStart(2, '0') + 'h');
      parts.push(String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0') + 'm');
      parts.push(String(totalSec % 60).padStart(2, '0') + 's');
      if (labelEl && labelEl.textContent !== stage.label) labelEl.textContent = stage.label;
      if (countdownEl) countdownEl.textContent = days >= 10 ? '' : parts.join(' ');
      bar.hidden = false;
      if (announce) announce.hidden = true;
    }

    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Email popup (once per visitor) ---------- */

  each('[data-email-popup]', function (popup) {
    var key = popup.getAttribute('data-storage-key') || 'minkmods_email_popup_dismissed';
    var delay = Math.max(20, parseInt(popup.getAttribute('data-delay') || '20', 10) || 20) * 1000;
    var closeBtns = popup.querySelectorAll('[data-email-popup-close]');
    var loadedAt = Date.now();

    function markSeen() {
      try {
        localStorage.setItem(key, '1');
      } catch (e) {
        /* ignore */
      }
    }

    function dismiss() {
      markSeen();
      popup.classList.remove('is-open');
      popup.hidden = true;
    }

    function open() {
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
    }

    closeBtns.forEach(function (btn) { btn.addEventListener('click', dismiss); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });
    popup.addEventListener('click', function (event) {
      if (event.target === popup) dismiss();
    });
    document.querySelectorAll('.popup__form, .signup__form').forEach(function (form) {
      form.addEventListener('submit', markSeen);
    });

    // After a signup the page reloads: show the code (or the error) straight away, and never ask again.
    var posted = /[?&]customer_posted=true/.test(location.search);
    if (posted) markSeen();
    var postedHere = posted && location.hash.indexOf('#SignupForm') !== 0 && popup.querySelector('[role="status"]');
    if (postedHere || popup.querySelector('[role="alert"]')) {
      open();
      return;
    }

    try {
      if (localStorage.getItem(key)) return;
    } catch (e) {
      /* show anyway */
    }
    if (document.documentElement.classList.contains('is-intl')) return;

    function onScreen(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
    }

    // Wait while the visitor is typing in a field, has the cart open, is trying the logo demo, or has a product
    // gallery where the card would open.
    function visitorBusy() {
      var active = document.activeElement;
      if (active && active.matches && active.matches('input, select, textarea') && !popup.contains(active)) return true;
      if (document.querySelector('[data-cart-drawer].is-open')) return true;
      var touched = (window.MinkMods && window.MinkMods.demoTouched) || 0;
      if (touched && Date.now() - touched < 20000) return true;
      var demo = document.querySelector('[data-emblem-controls]');
      if (demo && onScreen(demo)) return true;
      var cardTop = window.innerHeight - 320;
      return Array.prototype.some.call(document.querySelectorAll('[data-main-media], [data-slides], .pdp__thumbs'), function (el) {
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.bottom > cardTop && r.top < window.innerHeight;
      });
    }

    var shown = false;
    function show() {
      if (shown) return;
      if (visitorBusy()) {
        setTimeout(show, 5000);
        return;
      }
      shown = true;
      open();
    }

    if (!window.matchMedia('(min-width: 990px)').matches) {
      setTimeout(show, delay);
    } else {
      // Laptops: only when the mouse leaves through the top, or after the delay once the hero's buy row is gone.
      document.addEventListener('mouseout', function (event) {
        if (event.relatedTarget || event.clientY > 0) return;
        if (Date.now() - loadedAt < 20000) return;
        show();
      });
      setTimeout(function () {
        var heroBuy = document.querySelector('[data-hero-buy]');
        if (!heroBuy || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(function (entries) {
          if (entries[0].boundingClientRect.bottom < 0) show();
        }).observe(heroBuy);
      }, delay);
    }
  });

  /* ---------- Accordions ---------- */

  each('[data-accordion]', function (accordion) {
    var trigger = accordion.querySelector('.accordion__trigger');
    var panel = accordion.querySelector('.accordion__panel');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', function () {
      var open = accordion.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    });
  });

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.faq__item > summary, .pdp__details > summary');
    if (!summary || summary.parentNode.open) return;
    track('faq_open', { q: summary.textContent.trim().slice(0, 80) });
  });

  /* The native header disclosure is enhanced in shared-navigation.js. */

  /* ---------- Collection sort ---------- */

  each('[data-collection-sort]', function (select) {
    // New collection controls submit an ordinary GET form, including selected filters.
    if (select.form) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Product zones (variant picker + bundles + gallery) ---------- */

  each('[data-product-zone]', function (zone) {
    var moneyFormat = zone.getAttribute('data-money-format') || '${{amount}}';
    var bundleMode = zone.getAttribute('data-bundle-mode') || '';
    var requireOption = zone.getAttribute('data-require-option') === 'true';
    var form = zone.querySelector('form[action*="/cart/add"]') || zone.querySelector('form');
    if (!form) return;

    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[name="quantity"], [data-qty-input]');
    var atcButton = form.querySelector('[data-atc]');
    var priceDisplay = zone.querySelector('[data-price-display]');
    var variantStatus = form.querySelector('[data-variant-status]');
    var bundleButtons = zone.querySelectorAll('.bundle[data-qty]');
    var variantJsonEl =
      zone.parentElement.querySelector('[data-variant-json]') ||
      document.querySelector('[data-variant-json]');
    var variants = null;
    var selectedVariant = null;

    if (variantJsonEl) {
      try {
        variants = JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        variants = null;
      }
    }

    function refreshBundlePrices(priceCents) {
      if (bundleMode !== 'fixed') return;
      var selected = zone.querySelector('.bundle.is-selected');
      var atcTotal = form.querySelector('[data-atc-total]');
      if (selected && atcTotal) {
        var label = selected.querySelector('[data-bundle-price]');
        if (label) atcTotal.textContent = label.textContent;
      }
      if (priceDisplay && priceCents != null && !selected) {
        priceDisplay.textContent = formatMoney(priceCents, moneyFormat);
      }
    }

    bundleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        bundleButtons.forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        if (qtyInput) qtyInput.value = btn.getAttribute('data-qty');
        refreshBundlePrices();
      });
    });

    function setVariant(match) {
      selectedVariant = match;
      if (variantStatus) { variantStatus.hidden = true; variantStatus.textContent = ''; }
      if (!match) {
        if (idInput) idInput.value = '';
        var incomplete = !!zone.querySelector('[data-option-fieldset]') && Array.prototype.some.call(zone.querySelectorAll('[data-option-fieldset]'), function (fieldset) { return !fieldset.querySelector('input[type="radio"]:checked'); });
        if (priceDisplay && variants && variants.length) {
          var minimum = Math.min.apply(null, variants.map(function (variant) { return variant.price; }));
          var price = 'From ' + formatMoney(minimum, moneyFormat);
          priceDisplay.textContent = price;
          var stickyBase = document.querySelector('[data-sticky-price]');
          if (stickyBase) stickyBase.textContent = price;
        }
        if (variantStatus && !incomplete) {
          variantStatus.textContent = 'This option combination is unavailable. Choose different options.';
          variantStatus.hidden = false;
        }
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.removeAttribute('aria-disabled');
          atcButton.textContent = incomplete ? atcButton.getAttribute('data-pick-label') || 'Select an option' : 'Choose another option';
          var stickyChoose = document.querySelector('[data-sticky-button]');
          if (stickyChoose) {
            stickyChoose.disabled = false;
            stickyChoose.textContent = incomplete ? 'Choose options' : 'Choose another option';
          }
        }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceDisplay) priceDisplay.textContent = formatMoney(match.price, moneyFormat);
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price, moneyFormat);
      if (atcButton) {
        atcButton.removeAttribute('aria-disabled');
        if (!match.available) {
          atcButton.disabled = true;
          atcButton.textContent = 'Sold out';
          if (variantStatus) { variantStatus.textContent = 'This option is sold out. Choose an available option.'; variantStatus.hidden = false; }
        } else {
          atcButton.disabled = false;
          atcButton.innerHTML = 'Add to cart, <span data-atc-total>' + formatMoney(match.price, moneyFormat) + '</span>';
        }
      }
      var stickyButton = document.querySelector('[data-sticky-button]');
      if (stickyButton) {
        stickyButton.disabled = !match.available;
        stickyButton.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      refreshBundlePrices(match.price);
    }

    var fieldsets = zone.querySelectorAll('[data-option-fieldset]');
    if (fieldsets.length && variants) {
      var selectFromFields = function () {
          var selectedOptions = [];
          zone.querySelectorAll('[data-option-fieldset]').forEach(function (fs) {
            var checked = fs.querySelector('input[type="radio"]:checked');
            selectedOptions.push(checked ? checked.value : null);
          });
          if (selectedOptions.some(function (o) {
            return o == null;
          })) {
            setVariant(null);
            return;
          }
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return opt === selectedOptions[i];
            });
          });
          setVariant(match || null);
          if (match && fieldsets.length === 1) track('size_pick', { value: String(selectedOptions[0]).slice(0, 40) });
      };
      var requestedId = new URLSearchParams(window.location.search).get('variant');
      var requestedVariant = requestedId && variants.find(function (variant) { return String(variant.id) === requestedId; });
      // A Shopify variant deep link is an explicit choice; a photographed wheel preset can refine it later.
      if (requestedVariant) {
        fieldsets.forEach(function (fieldset, index) {
          fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = input.value === requestedVariant.options[index]; });
        });
      }
      selectFromFields();
      fieldsets.forEach(function (fieldset) {
        fieldset.addEventListener('change', selectFromFields);
      });
      // Browsers can restore radio choices on Back without firing a change event.
      window.addEventListener('pageshow', selectFromFields);
    }

    zone.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.getAttribute('data-pdp-qty'), 10) || 0;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Gallery. Photos only: the main picture is a row the buyer swipes, and the thumbnails follow it.
    // With a clip: a photo thumbnail swaps the main photo; a clip thumbnail plays that clip in its place.
    var mainMedia = zone.querySelector('[data-main-media]');
    var slides = mainMedia ? mainMedia.querySelector('[data-slides]') : null;
    var thumbs = Array.prototype.slice.call(zone.querySelectorAll('[data-thumb]'));
    var renderTag = mainMedia ? mainMedia.querySelector('[data-render-tag]') : null;
    var shownIndex = 0;
    var galleryStatus = zone.querySelector('[data-gallery-status]');

    function markThumb(index) {
      shownIndex = index;
      thumbs.forEach(function (thumb, i) {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (galleryStatus) galleryStatus.textContent = 'Product media ' + (index + 1) + ' of ' + thumbs.length + '.';
      var active = thumbs[index];
      var row = active && active.parentNode;
      // Keeps the marked thumbnail in view inside its own row, without moving the page.
      if (row && row.scrollTo && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2, behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      if (renderTag && active) renderTag.hidden = active.getAttribute('data-render') !== 'true';
    }

    if (slides) {
      slides.addEventListener('keydown', function (event) {
        if (event.target !== slides || !thumbs.length) return;
        var index = shownIndex;
        if (event.key === 'ArrowRight') index = Math.min(thumbs.length - 1, index + 1);
        else if (event.key === 'ArrowLeft') index = Math.max(0, index - 1);
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = thumbs.length - 1;
        else return;
        event.preventDefault();
        thumbs[index].click();
      });
      var slideQueued = false;
      slides.addEventListener('scroll', function () {
        if (slideQueued) return;
        slideQueued = true;
        requestAnimationFrame(function () {
          slideQueued = false;
          var index = Math.round(slides.scrollLeft / (slides.clientWidth || 1));
          if (index !== shownIndex && thumbs[index]) markThumb(index);
        });
      }, { passive: true });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        if (!mainMedia) return;
        markThumb(index);
        if (slides) {
          if (slides.scrollTo) slides.scrollTo({ left: index * slides.clientWidth, behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          else slides.scrollLeft = index * slides.clientWidth;
          return;
        }
        var mainImage = mainMedia.querySelector('[data-main-image]');
        if (!mainImage) {
          mainImage = document.createElement('img');
          mainImage.setAttribute('data-main-image', '');
          mainImage.width = 1100;
          mainImage.height = 1100;
          if (mainMedia.hasAttribute('data-reel')) mainImage.className = 'reel__still';
          mainMedia.insertBefore(mainImage, mainMedia.firstChild);
        }
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumb.getAttribute('data-thumb');
        mainImage.alt = thumb.getAttribute('data-alt') || '';
        var clip = thumb.getAttribute('data-clip');
        mainMedia.dispatchEvent(new CustomEvent(clip ? 'reel:play' : 'reel:stop', { detail: { src: clip || '', webm: thumb.getAttribute('data-clip-webm') || '' } }));
      });
    });

    // The photo column sticks on wide screens; its height keeps it clamped inside short laptop windows.
    var mediaCol = zone.querySelector('.pdp__media');
    if (mediaCol && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        zone.style.setProperty('--media-h', mediaCol.offsetHeight + 'px');
      }).observe(mediaCol);
    }

    refreshBundlePrices();
  });

  /* ---------- Sticky add-to-cart bar: shown while the real button is off screen ---------- */

  guard(function () {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!stickyBar) return;
    var zone = document.querySelector('[data-product-zone]');
    var stickyButton = stickyBar.querySelector('[data-sticky-button]');
    var form = zone ? zone.querySelector('form') : null;

    var atcEl = zone ? zone.querySelector('[data-atc]') : null;

    if (zone) {
      var mediaEl = zone.querySelector('.pdp__media');
      var stickyQueued = false;

      var syncSticky = function () {
        stickyQueued = false;
        // Desktop waits for the gallery to clear the bar; phones keep the purchase action within reach.
        var barTop = window.innerHeight - (stickyBar.offsetHeight || 64);
        var rect = mediaEl ? mediaEl.getBoundingClientRect() : null;
        var overGallery = !!rect && rect.top < window.innerHeight && rect.bottom > barTop;
        var atcRect = atcEl ? atcEl.getBoundingClientRect() : zone.getBoundingClientRect();
        var header = document.querySelector('.site-header');
        var headerRect = header && header.getBoundingClientRect();
        var safeTop = headerRect && headerRect.top <= 0 ? Math.max(0, headerRect.bottom) : 0;
        // A sliver of the main button behind the sticky header does not give the buyer a usable action.
        var atcSeen = atcRect.height > 0 && atcRect.top >= safeTop && atcRect.bottom <= window.innerHeight;
        var onPhone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        var keyboardOpen = window.visualViewport && window.innerHeight - window.visualViewport.height > 120 && form && form.contains(document.activeElement);
        // Social visitors can reach the choices from the first gallery frame on a phone.
        var on = !atcSeen && (onPhone || !overGallery) && !keyboardOpen;
        var state = form && window.MinkMods && window.MinkMods.purchaseState ? window.MinkMods.purchaseState(form) : null;
        if (state && stickyButton) {
          stickyButton.disabled = state.disabled;
          stickyButton.textContent = state.label;
        }
        stickyBar.hidden = false;
        stickyBar.classList.toggle('is-visible', on);
        document.body.classList.toggle('has-sticky-bar', on);
        document.documentElement.style.setProperty('--sticky-h', on ? stickyBar.offsetHeight + 'px' : '0px');
      };
      var queueSticky = function () {
        if (stickyQueued) return;
        stickyQueued = true;
        requestAnimationFrame(syncSticky);
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(queueSticky, { threshold: 0 }).observe(atcEl || zone);
      }
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      window.addEventListener('load', queueSticky);
      zone.addEventListener('input', queueSticky);
      zone.addEventListener('change', queueSticky);
      zone.addEventListener('minkmods:purchase-update', queueSticky);
      document.addEventListener('focusin', queueSticky);
      document.addEventListener('focusout', queueSticky);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', queueSticky);
      queueSticky();
    }

    if (stickyButton && form) {
      stickyButton.addEventListener('click', function () {
        if (window.MinkMods && window.MinkMods.validateProductPurchase && !window.MinkMods.validateProductPurchase(form)) return;
        var open = Array.prototype.find.call(zone.querySelectorAll('[data-option-fieldset]'), function (fs) {
          return !fs.querySelector('input[type="radio"]:checked');
        });
        if (open) {
          // Same outline and "Pick ..." line as a tap on the main button.
          if (window.MinkMods && window.MinkMods.pointAtOption) {
            window.MinkMods.pointAtOption(open);
            return;
          }
          open.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = open.querySelector('input[type="radio"]');
          if (first) first.focus({ preventScroll: true });
          return;
        }
        // The bar only ever does what the real button would do.
        if (atcEl && atcEl.disabled) {
          atcEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // form.submit() fires no submit event, so on older phones it would skip the required fields and tick boxes.
        if (form.requestSubmit) form.requestSubmit();
        else if (atcEl) atcEl.click();
        else form.submit();
      });
    }
  });
})();
